import * as _ from 'lodash';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AuctionManageService } from 'app/manage-auctions/services/auction-manage/auction-manage.service';
import { CampaignTabsService } from 'app/campaign/services';
import { selectCurrentAuction } from '../../features/auction.selectors';
import { ModalAuctionDetailService } from '../../services/modal-auction-detail/modal-auction-detail.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-auction-detail-modal',
  templateUrl: './auction-detail-modal.component.html',
  styleUrls: ['./auction-detail-modal.component.scss']
})

export class AuctionDetailModalComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Input() data

  public params: any = null;

  public auctionBidders: any = null;
  public selectedBidder: any = null;

  public step: string = 'itemDetails';
  public prevStep: string = '';
  public placeOfCall: string = '';

  public currentAuctionCampaign$ = this.store.pipe(
    select(selectCurrentAuction),
  )

  constructor(
    private store: Store,
    private auctionManageService:AuctionManageService,
    public tabsService: CampaignTabsService,
    private modalAuctionDetailService: ModalAuctionDetailService,
    ) { }

  ngOnInit(): void {
    this.placeOfCall = this.data.placeOfCall;

    this.step = this.data.placeOfCall;
    this.prevStep = this.data.placeOfCall;

    this.params = this.data.params;

    this.currentAuctionCampaign$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((auctionCampaign) => {
      this.auctionBidders = this.auctionManageService.getAuctionBidders(auctionCampaign)

      // Directly open bidder details
      if (this.data.placeOfCall === 'bidderDetails' && this.data.userId) {
        this.seeBidderDetails({bidInfo: {userId: this.data.userId}})
      }
    })
  }

  seeItemDetails(params) {
    this.prevStep = this.step;
    this.step = 'itemDetails';

    this.params = params;
  }

  seeBidderDetails(bid) {
    this.prevStep = this.step;
    this.step = 'bidderDetails';

    const userId = bid.bidInfo.userId || bid.bidInfo.userInfo.id;
    const selectedBidder = this.auctionBidders.find(item => item.bidInfo.userInfo.id === userId)

    this.selectedBidder = _.cloneDeep(selectedBidder);
  }

  backToPrevStep() {
    this.step = this.prevStep;
  }

  backToSearch() {
    this.step = 'search';
  }

  close() {
    this.modalAuctionDetailService.close();
  }
}
